import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEyeOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      fillRule="evenodd"
      d="M18.666 5a.667.667 0 0 1 .472 1.138L5.804 19.47a.669.669 0 0 1-1.096-.21.667.667 0 0 1 .154-.733l1.83-1.83a15.73 15.73 0 0 1-1.609-1.107 18.187 18.187 0 0 1-2.941-2.847.667.667 0 0 1 0-.822C2.32 11.694 6.584 6.333 12 6.333a8.4 8.4 0 0 1 1.548.145c.875.169 1.724.45 2.527.837l2.12-2.12A.667.667 0 0 1 18.666 5ZM3.542 12.333a17.944 17.944 0 0 0 2.36 2.206c.557.44 1.147.836 1.764 1.185L9.22 14.17a3.333 3.333 0 0 1 4.619-4.619l1.228-1.228a8.649 8.649 0 0 0-1.759-.533A7.089 7.089 0 0 0 12 7.667c-3.95 0-7.38 3.458-8.458 4.666Zm6.458 0c.001.297.07.59.2.856l2.648-2.648a2.052 2.052 0 0 0-2.267.38A2.007 2.007 0 0 0 10 12.333Zm.471 5.857a8.448 8.448 0 0 0 1.529.143c5.416 0 9.679-5.36 9.858-5.588a.666.666 0 0 0 0-.822 18.218 18.218 0 0 0-2.944-2.85.667.667 0 0 0-.816 1.055 17.95 17.95 0 0 1 2.36 2.205C19.378 13.542 15.949 17 12 17a7.11 7.11 0 0 1-1.298-.123.676.676 0 0 0-.792.656.666.666 0 0 0 .561.657Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEyeOff;
